import * as React from 'react';
import { useCallback, useEffect } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import GraphPanel from "./GraphPanel/GraphPanel";
import {useMapContext} from "../../contexts/MapContext";
import DataSnackbar from "./DataSnackbar";
import {Tooltip} from "@mui/material";

const MIN_DRAWER_WIDTH = 300;
const MAX_DRAWER_WIDTH = 800;
const DEFAULT_DRAWER_WIDTH = 500;

export default function SideBar() {
    const [open, setOpen] = React.useState(true);
    const [drawerWidth, setDrawerWidth] = React.useState(DEFAULT_DRAWER_WIDTH);
    const [isResizing, setIsResizing] = React.useState(false);

    const {
        stormMode,
        selectedFeature,
        handleCloseDraggable,
        subcatchmentNameJSON,
    } = useMapContext();

    const handleMouseMove = useCallback((e) => {
        if (!isResizing) return;
        e.preventDefault();
        
        const newWidth = window.innerWidth - e.clientX;
        if (newWidth >= MIN_DRAWER_WIDTH && newWidth <= MAX_DRAWER_WIDTH) {
            setDrawerWidth(newWidth);
        }
    }, [isResizing]);

    const handleMouseUp = useCallback(() => {
        setIsResizing(false);
    }, []);

    useEffect(() => {
        if (isResizing) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isResizing, handleMouseMove, handleMouseUp]);

    if (!stormMode || !selectedFeature.Data) return null;

    const handleDrawerClose = () => {
        handleCloseDraggable();
    };

    const handleMouseDown = (e) => {
        e.preventDefault();
        setIsResizing(true);
    };

    return (
        <Box sx={{ display: 'flex' }}>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    height: '100%',
                    position: 'relative',
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        backgroundColor: 'rgb(7, 19, 23)',
                        opacity: 0.9,
                        transition: isResizing ? 'none' : 'width 0.2s ease-in-out',
                    },
                }}
                variant="persistent"
                anchor="right"
                open={open}
            >

                <Box
                    sx={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        bottom: 0,
                        width: '8px',
                        cursor: 'ew-resize',
                        backgroundColor: isResizing ? '#8bc2e0' : 'transparent',
                        '&:hover': {
                            backgroundColor: '#8bc2e0',
                        },
                        opacity: isResizing ? 0.7 : 0.5,
                        zIndex: 1300,
                    }}
                    onMouseDown={handleMouseDown}
                />
                <List>
                    <Box sx={{height: '60px'}}>
                    </Box>
                    <Divider/>
                    <ListItem key="Close Sidebar" disablePadding>
                        <ListItemButton onClick={handleDrawerClose}>
                            <Tooltip title="Close Sidebar" placement="right">
                                <ListItemIcon color="red">
                                    <KeyboardDoubleArrowRightIcon sx={{ color: "#8bc2e0" }}/>
                                </ListItemIcon>
                            </Tooltip>
                        </ListItemButton>
                    </ListItem>
                    <Divider/>
                    <Box sx={{padding: '10px', color: '#8bc2e0', fontSize: '18px', fontWeight: 'bold', display: "flex", justifyContent: "center", width: "100%"}}>
                        {subcatchmentNameJSON[selectedFeature.Data.NAME] || selectedFeature.Data.NAME || ''}
                    </Box>
                    <ListItem>
                        <Box sx={{
                            display: "flex", 
                            justifyContent: "center", 
                            alignItems: "center", 
                            width: "100%",
                            margin: "0 auto",

                        }}>
                            <GraphPanel sx={{ width: "100%" }}/>
                        </Box>
                    </ListItem>
                    <ListItem>
                        <Box sx={{width: "100%", marginTop: "70px"}}>
                            <Box sx={{padding: '0 10px 0 10px'}}>
                                <DataSnackbar selectedFeatureData={selectedFeature.Data} />
                            </Box>
                        </Box>
                    </ListItem>
                </List>



            </Drawer>
        </Box>
    );
}
